import React, { Component } from 'react'

export default class WorksAllodi extends Component {
    render() {
        return (
            <div class="modal" id="worksallodi" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-full" role="document">
                    <div class="modal-content">
                    <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
            </div>
                        <div class="modal-header">
                            <h5 class="modal-title"><strong>&quot;Italo allodi. Ascesa e caduta di un Principe del calcio&quot; </strong>(biografia): <em>Italic-peQuod, 2012, Milano.</em></h5>
                           
                        </div>
                        <div class="modal-body p-4" id="result">





                            <div align="left">

                                <br /> <br />

                                <br /><br />
                                Se il calcio è “dubbio costante e decisione rapida”, come ha ben scritto Osvaldo Soriano, e quindi “arte dell’imprevisto”, secondo quanto suggerisce Eduardo Galeano, non a caso Italo Allodi (1928-1999) ne è diventato un grande protagonista. <br/>
                                    Geniale innovatore, capace di vedere prima e più lontano degli altri, e brillante stratega, dotato di un talento e di uno stile che nel mondo calcistico hanno avuto pochi uguali, Allodi è stato innanzitutto un uomo capace di farsi dal niente, un tipico self-made man del “miracolo italiano” degli anni Sessanta. Nato e cresciuto in provincia da una modesta famiglia, interrotti presto gli studi per fare il calciatore, al termine di una non brillante carriera di mediano ha saputo inventare un mestiere nuovo, per sé e per il calcio, creando la figura del general manager che sarebbe diventata un modello per tutti. Dalla rampa di lancio del Mantova, ha raggiunto i massimi traguardi con la Grande Inter di Moratti ed Herrera, per poi mietere altri successi con la Juventus pochi anni dopo. Poi ecco quella che forse è stata la sua più grande intuizione: dare vita al Centro studi e al Supercorso per allenatori di Coverciano, con un inedito innesto di cultura nel calcio che avrebbe portato a una sua radicale emancipazione. Ed era in procinto di compiere con il Napoli di Maradona l’ennesima impresa quando è stato preso di mira dalla cattiva sorte, prima coinvolto in un’inchiesta per illeciti sportivi, dalla quale sarebbe uscito del tutto scagionato ma ferito nel profondo, poi colpito dal grave malanno fisico che lo ha condannato a un mesto e solitario finale di partita. <br/>
                                        Questo e altro rendono esemplare la sua vicenda umana e professionale, che trova qui un’attenta e appassionata ricostruzione realizzata anche attraverso le testimonianze di tanti personaggi che lo hanno conosciuto da vicino, da Gustavo Giagnoni ad Arrigo Sacchi, da Sandro Mazzola a Massimo Moratti. L’esito è quello di una biografia avvincente come un romanzo, con il ritratto di un uomo e insieme di un’epoca in cui nella Bassa la domenica si andava al fiume in bicicletta, i campioni  facevano di nome Tarcisio, Giacinto o Aristide, e il calcio si vedeva ancora in bianco e nero.
                                        
 <br /><br />


                                        <strong>ne hanno scritto:</strong> <br /><br />



                                        Sergio Martini, La Voce di Mantova, 20/7/13<br />
                                        a.cer. La Gazzetta dello sport, 20/1/13<br />
                                        Gianni Mura, La Repubblica, 28/2/12<br />
                                        Vanni Buttasi, La Gazzetta di Parma, 31/12/12<br />
                                        Alessandro De Bertolini, Corriere della sera/Trentino, 23/1/13<br />
                                        Alessandro Franceschini, L’Adige, 28/11/12<br />
                                        Carlo Martinelli, Il Trentino, 28/11/12<br />
                                        Massimo Raffaeli, Il Manifesto-Inserto Alias, 10/2/13<br />
                                        a.g. La Voce di Mantova, 11/1/13<br />
                                        <br /><br />
                                        E parlato:
<br /><br />
                                        L. Suarez, Studio Sport, Italia 1, 19/1/13<br />
                                        Felice Cimatti, Fahrenheit, Radio 3, 3/7/13<br />
                                        Pagina 3, Radio 3, 9/2/13<br />


</div>



<div align="center">

<strong> Selezione Stampa</strong>

<br/><br/><br/><br/><br/>

<table border="0" align="center" cellspacing="7">
	<tr>
	   <td align="center" width="100">Alias (inserto cultura de Il Manifesto),
		10/feb/2013, "La parabola di Allodi, da Moratti a Maradona" di Matteo Patrono.(2.1Mb)</td> <td><a href="rec/allodi_paraboladiallodi.zip"><img
		src="./img/rec/allodi-paraboladiallodi-small.png"
		alt="scarica in formato zip" 
	width="151" height="280"></img></a>
		</td>
 </tr> 
 <tr>
		<td align="center" width="100">Il Trentino, 28/nov/2012:
		"Tamburini e lo 'Zio Italo', la biografia di un Gentleman" di Carlo Martinelli.(303kb)</td> <td><a href="rec/allodi-zioitalo.zip"><img
		src="./img/rec/allodi-zioitalo-small.png" 
alt="scarica in formato zip"
width="156"
		height="258"></img></a>
		</td>
</tr> 
<tr>
<td align="center" width="100">La Gazzetta di Parma, 31/dic/2012:
		"Italo Allodi: L'epopea di un 'Principe del pallone'" di Vanni Buttasi(41k)</td> <td><a href="rec/allodiprincipedelpallone.zip"><img
		src="./img/rec/allodiprincipedelpallone-small.png" 
alt="scarica in formato zip"
width="156"
		height="258"></img></a>
		</td>
</tr>

</table>

</div>










            </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
                                </div>
                            </div>
                        </div>
                    </div>


                    )
                  }
                }
